import Button, { BUTTON_TYPE_CLASSES } from "../../components/button/button.component";
import EventCard from "../../components/eventCard/eventCard.component";
import Hero from "../../components/hero/hero.component";
import "./home.styles.scss";
import bg_video from "../../assets/images/waterfall.mp4"
import Footer from "../../components/footer/footer.component";
import heroImage from '../../assets/images/ololokwe.jpg';
import hiker from '../../assets/images/nat-8.jpg';
import { BiWorld } from "react-icons/bi";
import { FaUserDoctor } from "react-icons/fa6";
import { FaHandsHelping } from "react-icons/fa";
import { IoShieldCheckmarkOutline } from "react-icons/io5";
import { useFetchUpcomingAdventures } from "../../api/queries/adventureQueries";
import { useFetchUpcomingPogrames } from "../../api/queries/programmeQueries";

const Home = () => {
    var upcomingEvents = useFetchUpcomingAdventures();
    var upcomingProgrammes = useFetchUpcomingPogrames();

    return (
        <>
            <div className="home">
                <div className="home__hero">
                    <Hero 
                        backgroundImage={heroImage}
                        headerPrimary={"Where Every Trail Tells A Story"}
                        headerSecondary={"Unleash your Wanderlust"}
                    />
                </div>
                <section className="home__events">
                    <div className="home__events-header">
                        <h2>
                            <span className="home__events-header--sub">Hike with Us</span>
                            <span className="home__events-header--main"> Events &#x2022; Our Upcoming Events</span>
                        </h2>
                        <a href="/events" className="home__events-header--link">view more <i className="fa-solid fa-angle-right fa-sm"></i></a>
                    </div>
                    {upcomingEvents?.data?.totalItems!==0 ?
                        <>
                            <div className="home__events-cards">
                                {upcomingEvents?.data?.results?.map((adventure) => {
                                    return (
                                        <div className="home__events-card">
                                            <EventCard adventure={adventure}/>
                                        </div>
                                    )
                                })}
                            </div>
                            <div className="home__events-link">
                                <Button link="/events">View More</Button>
                            </div>
                        </>
                        : <p className="home__events-blank">Oops!<br></br> No Upcoming Events, Come Back Later</p>
                    }
                </section>
                <section className="home__challenges">
                    <div className="header__secondary u-margin-bottom-small u-text-align-centre">
                        <h2>
                            <span className="header__secondary--sub">Let The challenge begin</span>
                            <span className="header__secondary--main"> Book Your next Challenge</span>
                        </h2>
                    </div>
                    {upcomingProgrammes?.data?.totalItems !== 0 ?
                        <>
                            <div className="home__challenges-cards">
                                {upcomingProgrammes?.data?.results?.map((adventure) => {
                                    return (
                                        <div className="home__events-card">
                                            <EventCard adventure={adventure}/>
                                        </div>
                                    )
                                })}
                            </div>
                            <div className="home__events-link u-margin-bottom-small">
                                <Button link="/events">Book Now</Button>
                            </div>
                        </>
                        : <p className="home__challenges-blank">Oops!<br></br> No Upcoming Challenges, Come Back Later</p>
                    }
                </section>
                <section className="home__features">
                    <div className="home__features-banner">
                        <h2>
                            <span className="home__features-banner--main"> adventures &#x2022; more than hiking </span>
                            <span className="home__features-banner--sub2"> to more places with affordable rates </span>
                        </h2>
                    </div> 
                    <div class="home__features-cards u-margin-bottom-small">
                        <div class="feature-box">
                            <i class="feature-box__icon"><BiWorld /></i>
                            <h3 class="heading-tertiary u-margin-bottom-small">
                                Explore the world
                            </h3>
                            <p class="feature-box__text">
                                Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic maxime nam et assumenda magni amet delectus consectetur quisquam iste optio.
                            </p> 
                        </div>

                        <div class="feature-box">
                            <i class="feature-box__icon"><FaUserDoctor /></i>
                            <h3 class="heading-tertiary u-margin-bottom-small">
                               Paramedic on Board
                            </h3>
                            <p class="feature-box__text">
                                Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic maxime nam et assumenda magni amet delectus consectetur quisquam iste optio.
                            </p> 
                        </div>

                        <div class="feature-box">
                            <i class="feature-box__icon"><FaHandsHelping /></i>
                            <h3 class="heading-tertiary u-margin-bottom-small">
                                Great Programmes
                            </h3>
                            <p class="feature-box__text">
                                Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic maxime nam et assumenda magni amet delectus consectetur quisquam iste optio.
                            </p> 
                        </div>

                        <div class="feature-box">
                            <i class="feature-box__icon"><IoShieldCheckmarkOutline /></i>
                            <h3 class="heading-tertiary u-margin-bottom-small">
                                Mamba Hiker Budges
                            </h3>
                            <p class="feature-box__text">
                                Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic maxime nam et assumenda magni amet delectus consectetur quisquam iste optio.
                            </p> 
                        </div>
                    </div>
                </section>
                <section className="home__cta">
                    <div className="home__cta-backgroundImage"></div>
                    <div className="home__cta-content">
                        {/* <p className="home__cta-content--main">From casual strolls to epic hikes, we’ve got you covered<br/>Join our community for customized trails and insider tips</p> */}
                        <p className="home__cta-content--main">Find Your Path, Find Your People</p>
                    
                        <div className="home__cta-btn">
                            <Button buttonType={BUTTON_TYPE_CLASSES.inverted}>Join Our Community</Button>
                        </div>
                    </div>
                </section>
                <section className="home__testimonials">
                <div className="bg-video">
                        <video className="bg-video__content" autoPlay muted loop>
                            <source src={bg_video} type="video/mp4"/>
                            Your Browser is not supported!
                        </video>
                    </div>
                    <div className="header__secondary u-margin-bottom-small u-text-align-centre">
                        <h2>
                        <span className="header__secondary--main u-margin-bottom-medium"> What Our Adventurers Are Saying </span>
                        </h2>
                    </div>
                    <div className="home__testimonials-cards">
                        <div class="story">
                            <figure class="story__shape">
                                <img src={hiker} alt="person on a tour" class="story__image"/>
                                <figcaption class="story__caption">Mary Smith</figcaption>
                            </figure>
                            <div class="story__text">
                                <h3 class="heading-tertiary u-margin-bottom-small">
                                    I had the best week ever with my family
                                </h3>
                                <p>
                                    Lorem ipsum, Impedit dolorum nesciunt repellat architecto aspernatur Impedit dolorum nesciunt dolor sit amet consectetur adipisicing elit. Iure facilis aliquid magnam quas non sit corporis vero sed officiis quidem vel, architecto aut porro? Impedit dolorum nesciunt repellat architecto aspernatur.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="u-footer-height home__footer">
                    <Footer/>
                </section>
            </div>
        </>
    );
}

export default Home;